import { useActiveAlertCount } from '../../modules/referenceView/AlertsSheet/hooks/useActiveAlertCount.ts';
import { selectIsInspectifyOrder } from '../../redux/features/selectors/orderSelectors.ts';
import { selectReferenceBarUI } from '../../redux/features/selectors/referenceBarUISelectors.ts';
import { useAppSelector } from '../../redux/hooks.ts';
import { Tkv2ReferenceBarItem } from './Tkv2ReferenceBarItem.tsx';
import { useTkv2HandleIconClick } from './useTkv2HandleIconClick.ts';

export const AlertsItem = () => {
  const { referenceViewOpen, selectedDataSheet } = useAppSelector(selectReferenceBarUI);
  const handleIconClick = useTkv2HandleIconClick();
  const activeAlertCount = useActiveAlertCount();
  const isInspectifyOrder = useAppSelector(selectIsInspectifyOrder);

  const isSelected = selectedDataSheet === 'craftsman-alerts' && referenceViewOpen;
  const label = activeAlertCount > 0 ? `Alerts (${activeAlertCount})` : 'Alerts';

  return (
    <Tkv2ReferenceBarItem
      id="alerts"
      label={label}
      icon="alarm-warning"
      isSelected={isSelected}
      alertCount={activeAlertCount}
      isInspectifyOrder={isInspectifyOrder}
      onClick={() => handleIconClick('craftsman-alerts')}
    />
  );
};
